import Component from "../abstracts/Component";
import { isMobile, MobileBreakpoint } from "../utils/MobileUtils";

export default class ListingCarouselComponent extends Component {
  get SELECTORS() {
    return {
      main: ".carousel-wrapper",
      prevArrow: "[data-prev-arrow]",
      nextArrow: "[data-next-arrow]",
    };
  }

  constructor(el) {
    super(el);
    this.main = $(this.SELECTORS.main);
    this.whatchRes = [];
    this.initCarousel = this.$component.attributes["carousel-active"].value;
    this.isWishlist = this.$component.dataset.wishlist === "true";
  }

  importLibrary() {
    if (!isMobile(MobileBreakpoint.Max767) && !this.isWishlist) {
      this.moduleLoader.loadCarouselAndExecute(
        () => {
          const productCards = document.querySelectorAll(this.SELECTORS.main);
          productCards.forEach((card) => {
            this.getImages(card);
          });
          this.initCarousels();
        },
        (error) => {
          console.error("failed to load slick ", error.stack);
        },
      );
    }
  }

  getImages(target) {
    let dataGallery = target.dataset.carouselGallery;
    let img = target.querySelector("img");
    let imageAlt = img.alt;
    // first split string and convert it to array
    let temp = dataGallery.split(",");
    $.each(temp, function (i, src) {
      const trimmedSrc = src.replace(/[\n\r]+/g, "").trim();
      if (trimmedSrc != "") {
        // Created elements
        let div = document.createElement("div");
        let picture = document.createElement("picture");
        let source = document.createElement("source");
        let img = document.createElement("img");

        // Set attributes to elements
        div.classList.add("slider-container");
        source.setAttribute("srcset", trimmedSrc);
        source.setAttribute("type", "image/webp");
        img.src = trimmedSrc;
        img.alt = imageAlt + " - " + (i + 2);
        img.setAttribute("data-src", trimmedSrc);

        // Append elements
        picture.append(source, img);
        div.appendChild(picture);
        target.append(div);
      }
    });
  }

  initSlick(carousel) {
    let parentNode = carousel.parentNode;
    let arrowL = parentNode.querySelector(this.SELECTORS.prevArrow);
    let arrowR = parentNode.querySelector(this.SELECTORS.nextArrow);
    if (arrowL || arrowR) {
      arrowL.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
      });
      arrowR.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
      });
      arrowL.addEventListener("keyup", (event) => {
        event.preventDefault();
        event.stopPropagation();
      });
      arrowR.addEventListener("keyup", (event) => {
        event.preventDefault();
        event.stopPropagation();
      });
      if (!carousel.classList.contains("slick-initialized")) {
        $(carousel).slick({
          prevArrow: arrowL,
          nextArrow: arrowR,
        });
      }
    }
  }

  initCarousels() {
    let carousels = document.querySelectorAll(".carousel-wrapper");
    carousels.forEach((carousel) => {
      if (!carousel.classList.contains("slick-initialized")) {
        const productLink = carousel.closest("a");
        carousel.addEventListener("mouseover", () => {
          this.initSlick(carousel);
        });
        if (productLink) {
          productLink.addEventListener("focus", (event) => {
            this.initSlick(carousel);
          });
        }
      }
    });
  }

  render() {
    super.render();
    if (
      document.querySelectorAll(".carousel-wrapper").length &&
      this.initCarousel !== "false"
    ) {
      this.importLibrary();
    }
  }
}
